import { WASHER, DRYER, ACCESSORIES } from '../constants/index';

const WASHER_MOCK = {
  specs: {
    defaultProductId: '328425526',
    category: WASHER
  },
  variants: [
    {
      name: 'Agitator/Impeller Type',
      id: '328425526',
      guid: 'b2a7875c-ab07-4ab2-9fb5-521ee16eb183',
      value: 'Agitator',
      __typename: 'BundleSDSkuAttributes'
    },
    {
      name: 'Agitator/Impeller Type',
      id: '329500038',
      guid: 'b2a7875c-ab07-4ab2-9fb5-521ee16eb183',
      value: 'Impeller',
      __typename: 'BundleSDSkuAttributes'
    }
  ]
};

const DRYER_MOCK = {
  specs: {
    defaultProductId: '312440161',
    category: DRYER
  },
  variants: [
    {
      name: 'Dryer Fuel Type',
      id: '312429905',
      guid: 'aacb73e8-7810-4d9e-8f23-e5ac86ef7f3f',
      value: 'Gas',
      __typename: 'BundleSDSkuAttributes'
    },
    {
      name: 'Dryer Fuel Type',
      id: '312440161',
      guid: 'aacb73e8-7810-4d9e-8f23-e5ac86ef7f3f',
      value: 'Electric',
      __typename: 'BundleSDSkuAttributes'
    }
  ]
};

export const LAUNDRY_MOCK = {
  [WASHER]: WASHER_MOCK,
  [DRYER]: DRYER_MOCK
};

export const LAUNDRY_ACCESSORIES_MOCK = [
  {
    categoryName: 'Storage & Stacking Accessories',
    offerings: [
      {
        offeringName: 'Storage Pedestal (Qty 2)',
        priority: 1,
        products: [
          {
            id: '202563165',
            defaultProductId: '202563165',
            priority: 1,
            quantity: 2,
            type: 'sku'
          }
        ]
      },
      {
        offeringName: 'Mini Washer Pedestal (Qty 1) + Storage Pedestal (Qty 1)',
        priority: 2,
        products: [
          {
            id: '322848433', // Mini Washer Pedestal
            defaultProductId: '322848433',
            priority: 1,
            quantity: 1,
            type: 'sku'
          },
          {
            id: '202563165', // Storage Pedestal
            defaultProductId: '202563165',
            priority: 2,
            quantity: 1,
            type: 'sku'
          }
        ]
      },
      {
        offeringName: 'Stacking Kit (Qty 1)',
        priority: 3,
        products: [
          {
            id: '323760403', // Stacking Kit
            defaultProductId: '323760403',
            priority: 1,
            quantity: 1,
            type: 'sku'
          }
        ]
      }
    ]
  }
];
